import React, { FC, useContext, forwardRef, Ref } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { up } from 'styled-breakpoints';
import { Menu } from '@fenderdigital/ui/Icons';
import { Focus } from '@fenderdigital/ui/utils/css';

export const UnSubscribedMobileButtonContainer = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 2;

  ${up('tablet-portrait')} {
    display: none;
  }
`;

interface UnSubscribedMobileButtonProps {
  onClick: () => void;
  ref?: Ref<HTMLButtonElement>;
}

const Button = styled.button`
  ${Focus};
  cursor: pointer;
  padding: 0.5rem;
`;

const UnSubscribedMobileButton: FC<UnSubscribedMobileButtonProps> = forwardRef(
  ({ onClick }, ref) => {
    const { colors } = useContext(ThemeContext);

    return (
      <Button
        type="button"
        onClick={onClick}
        aria-label="Open Menu"
        ref={ref}
        data-id="unsubscribed-mobile-button"
      >
        <Menu fill={colors.white} fontSize="1.5rem" aria-hidden />
      </Button>
    );
  },
);

export default UnSubscribedMobileButton;
